import { ReactNode } from 'react'

type DataAssetGroupProps = {
  name: string
  children: ReactNode
}

export function DataAssetGroup({ name, children }: DataAssetGroupProps) {
  return (
    <div className="bg-offwhite mb-5 flex flex-col overflow-hidden rounded-md shadow">
      <div className="border-b bg-muted p-2 font-semibold">{name}</div>
      <div className="flex flex-col gap-2 overflow-hidden p-2 text-xs">
        {children}
      </div>
    </div>
  )
}
